var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksPaySecurely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000366211,
    width: 64,
    height: 61.9522,
    rx: 12,
    fill: "#6395EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4569 49.9526H25.1059C23.1514 49.9509 21.5659 48.3671 21.5642 46.4109V43.6578C21.1902 44.2981 12.85 30.0036 12.5149 29.6766C11.509 28.0153 12.0212 25.8519 13.6657 24.8189L33.5406 12.5242C35.207 11.5015 37.3839 12.0221 38.4065 13.6868C39.2843 15.3784 46.4586 26.0777 46.8274 27.7405H48.455L48.4567 27.7422C50.4129 27.7438 51.9966 29.3277 52 31.2838V46.4106C51.9966 48.3668 50.4131 49.9509 48.4569 49.9526ZM24.26 38.266V46.4109C24.26 46.8793 24.6391 47.2567 25.1058 47.2584H48.4569C48.9253 47.2567 49.3044 46.8793 49.3044 46.4109V38.266H24.26ZM35.3906 14.6976C35.2372 14.6959 35.0856 14.738 34.9542 14.8189L15.0909 27.105C14.9005 27.2212 14.764 27.4099 14.7118 27.6256C14.6578 27.8429 14.6949 28.0721 14.8112 28.2625L21.5641 39.1804V31.2831C21.5658 29.3269 23.1513 27.7432 25.1058 27.7415H43.9412L36.1117 15.0996C35.9583 14.8485 35.6854 14.6952 35.3905 14.6969L35.3906 14.6976ZM24.26 35.5702H49.3041V31.2838C49.3041 30.8171 48.925 30.438 48.4566 30.438H25.1055C24.6388 30.438 24.2597 30.8171 24.2597 31.2838L24.26 35.5702ZM45.9565 45.019H43.5774C42.8327 45.019 42.2295 44.4141 42.2295 43.6711C42.2295 42.9263 42.8327 42.3232 43.5774 42.3232H45.9565C46.6928 42.3333 47.2859 42.9331 47.2859 43.6711C47.2859 44.4074 46.6928 45.0072 45.9565 45.019Z",
    fill: "#EFF7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksPaySecurely);
export default __webpack_public_path__ + "static/media/HowItWorksPaySecurely.0f91b7c4fa2720ceb94c1e60c20b4e90.svg";
export { ForwardRef as ReactComponent };